<template>
  <div id="container">
    <div v-if="showFirewall" class="firewall">
      <div v-if="editFirewall == false" class="firewall_border"></div>
      <div v-for="wall in firewall_array" :key="wall" :class="wall">
        <div class="wallpiece" v-for="f in 6" :key="f" :class="editFirewall && !firewall.hasOwnProperty(wall + f)
          ? 'wallpieceHover pointer'
          : ''
          " @click="openFirewallPiece(wall + f)">
          <template v-if="firewall.hasOwnProperty(wall + f)">
            <img class="firewall_img" :src="firewall[wall + f]" :alt="wall + f" />
          </template>
          <template v-else>
            {{ wall + f }}
          </template>
        </div>
      </div>
    </div>
    <div id="barqGrid">
      <template v-for="(sell, i) in use_sellingList" :key="i">
        <div v-if="sell.status != 'hacked' && sell.status != 'removed'" class="barqs pointer" @click="openBarq(sell, i)"
          :class="sell.status == 'offer'
            ? 'hellblau'
            : sell.status == 'approved'
              ? 'dunkelblau'
              : sell.status == 'sold'
                ? 'green'
                : ''
            ">
          <div class="name">{{ i }}</div>
          <div class="price">{{ numberFilter(sell.price) }} €</div>

          <!-- <div
          v-if="sell.status == 'open'"
          class="offer"
          @click="offerBarq(sell, i)"
        >
          {{ t("OFFER") }}
        </div> -->
        </div>
        <div v-if="sell.status == 'hacked' && editFirewall == true" class="hacked">
          <img src="../assets/hacked.svg" alt="seems you've been de-barq'd ..." />
          <div class="debarqd">seems you've been de-barq'd ...</div>
        </div>
        <div v-if="sell.status == 'hacked' && editFirewall == false" class="removed"></div>
      </template>
      <div v-if="gamePhase.phase == 0" class="howto">
        <!-- <div class="howto_img" :style="loadHowTo()"></div> -->
        <img class="howto_img" :src="loadHowTo()" />
      </div>
    </div>
    <Transition>
      <div v-if="currentOpenFirewall" class="currentOpenBarq">
        <Firewall :pieceId="currentOpenFirewall" :sprache="sprache" @close="closeFirewall" @send="sendFirewall" />
      </div>
    </Transition>

    <Transition>
      <div v-if="currentOpenBarq_Codes" class="currentOpenBarq_codes">
        <Codes :barqId="currentOpenBarq_Codes" :sprache="sprache" @close="closeBarq" @solved="codeSolved"
          @msg="setMessage" />
      </div>
    </Transition>
    <Transition>
      <div v-if="currentOpenBarq" class="currentOpenBarq">
        <template v-if="Object.prototype.hasOwnProperty.call(
          use_sellingList,
          currentOpenBarq
        )
          ">
          <div class="PopUPBarq">
            <Drawing ref="Drawing" :barqId="currentOpenBarq" :isMOS="isMOS" :barqs="barqs" :sprache="sprache"
              :status="use_sellingList[currentOpenBarq].status || 'non'" :lock="barqOnlyForView" @msg="setMessage" />

            <BarqAnswers :barqId="currentOpenBarq" :isMOS="isMOS" :value="use_sellingList[currentOpenBarq].price || 0"
              :sprache="sprache" @closeBarq="closeBarq" @getImage="getImage" :lock="barqOnlyForView" />
            <div class="roundInfo">
              <div>
                {{ roundInfo(gamePhase.phase) }}
              </div>
              <div>
                Turnover
                {{ parseInt(turnover.total).toLocaleString("de-DE") }},-
              </div>
              <div>
                {{ turnover.offered }} offered,
                {{ turnover.approved }} approved, {{ turnover.sold }} sold
              </div>
            </div>
          </div>
        </template>
      </div>
    </Transition>
  </div>
</template>

<script>
import Drawing from "./Drawing.vue";
import BarqAnswers from "./BarqAnswers.vue";
import Codes from "./Codes.vue";
import Dict from "../../services/dict_new.js";
import Firewall from "./Firewall";
import Fragen from "../../fragen.json";

export default {
  name: "BarqGrid",
  components: {
    Codes,
    Drawing,
    BarqAnswers,
    Firewall,
  },
  props: {
    sellingList: {
      type: Object,
      default: () => { },
    },
    // sample_sellingList: {
    //   type: Object,
    //   default: () => {},
    // },
    gamePhase: {
      type: Object,
      default: () => { },
    },
    barqs: {
      type: Object,
      default: () => { },
    },
    token: {
      type: String,
      default: () => "",
    },
    sprache: {
      type: String,
      default: () => "english",
    },
    firewall: {
      type: Object,
      default: () => { },
    },
    userName: {
      type: String,
      default: () => "undefined user",
    },
    resetCounter: {
      type: Number,
      default: () => 0,
    },
  },
  emits: ["msg", "addToPlayerData", "setSampleData", "resetCounter"],
  watch: {
    resetCounter: function (newVal) {
      this.resetCounter_local = newVal;
    },
    gamePhase: function (newVal) {
      // watch it
      console.log(newVal);
      console.log("GAMEPHASE WATCHER!");

      if (newVal.phase == 0) {
        console.log("inside phase 0");
        // this.use_sellingList = this.sample_sellingList;
        this.use_sellingList = {};
        for (const sell in this.sellingList) {
          // console.log(sell);
          if (this.isSampleBarq(sell)) {
            this.use_sellingList[sell] = this.sellingList[sell];
          }
        }
        // console.log(this.use_sellingList);
      } else if (newVal.phase == 1) {
        console.log("inside phase 1");
        // this.resetOpen();
        this.use_sellingList = {};
        let i = 0;
        for (const s of Object.keys(this.sellingList)) {
          if (!this.isSampleBarq(s)) {
            this.use_sellingList[s] = this.sellingList[s];
            if (i == 23) break;
            i++;
          }
        }
        // console.log(this.use_sellingList);
      } else {
        // this.resetOpen();
        for (const sell in this.sellingList) {
          if (!this.isSampleBarq(sell)) {
            this.use_sellingList[sell] = this.sellingList[sell];
          }
        }
      }

      if (newVal.resetOpen) {
        console.log("RESETTING");
        console.log(this.resetCounter_local);
        if (newVal.first.start == true && this.resetCounter_local < 1) {
          console.log("RESETTING FIRSt");
          this.resetOpen();
          this.$emit("resetCounter");
          // this.resetCounter++;
        } else if (newVal.second.start == true && this.resetCounter_local < 2) {
          console.log("RESETTING SECOND");
          this.resetOpen();
          this.$emit("resetCounter");
          // this.resetCounter++;
        }
        // else if (
        //   newVal.sample.start === true &&
        //   this.resetCounter_local == -1
        // ) {
        //   console.log("RESETTING SAMPLE");
        //   this.resetOpen();
        //   this.$emit("resetCounter");
        // }
      }
      // if (oldVal.resetOpen == false && newVal.resetOpen == true) {
      //   this.resetOpen();
      // }

      // try {
      //   if (newVal.first.start == true && newVal.first.end == false) {
      //   if (newVal.first.start == true && newVal.second.start == false) {
      //     this.resetOpen();
      //   }
      //   if (newVal.second.start == true && newVal.second.end == false) {
      //     this.resetOpen();
      //   }
      // } catch (e) {
      //   console.log(e);
      // }

      console.log("WATCHER");
      if (newVal.firewall) {
        console.log("inside");
        this.showFirewall = newVal.firewall.show;
        this.editFirewall = newVal.firewall.editable;
        // console.log(newVal.firewall.editable);
      }

      if (newVal.hack.barqul == "on") {
        this.clickable = true;
      } else {
        this.clickable = false;
      }
    },
    sellingList: function (newVal) {
      // this.use_sellingList = newVal;
      // watch it
      if (this.gamePhase.phase == 0) {
        // this.use_sellingList = this.sample_sellingList;
        this.use_sellingList = {};
        for (const sell in newVal) {
          if (this.isSampleBarq(sell)) {
            this.use_sellingList[sell] = newVal[sell];
          }
        }
      } else if (this.gamePhase.phase == 1) {
        this.use_sellingList = {};
        let i = 0;
        for (const s of Object.keys(newVal)) {
          if (!this.isSampleBarq(s)) {
            this.use_sellingList[s] = newVal[s];
            if (i == 17) break;
            i++;
          }
        }
        // console.log(this.use_sellingList);
      } else {
        for (const sell in newVal) {
          if (!this.isSampleBarq(sell)) {
            this.use_sellingList[sell] = newVal[sell];
          }
        }
      }

      //calc Turnover
      //reset
      this.turnover = {
        total: 0,
        approved: 0,
        offered: 0,
        sold: 0,
      };
      for (const s in this.use_sellingList) {
        if (this.use_sellingList[s].status == "non") continue;
        if (this.use_sellingList[s].status && this.use_sellingList[s].price) {
          this.turnover[this.use_sellingList[s].status]++;

          if (this.use_sellingList[s].status == "sold") {
            this.turnover.total += this.use_sellingList[s].price;
          }
        }
      }
    },
  },
  data() {
    return {
      use_sellingList: {},
      clickable: true,
      currentOpenBarq: "",
      currentOpenFirewall: "",
      currentOpenBarq_Codes: "",
      barqOnlyForView: false,
      imageStyle: "",
      firewall_array: ["T", "L", "B", "R"],
      showFirewall: false,
      editFirewall: true,
      resetCounter_local: this.resetCounter,
      turnover: {
        total: 0,
        approved: 0,
        offered: 0,
        sold: 0,
      },
      Fragen: Fragen,
      isMOS: false,
    };
  },

  methods: {
    t(word) {
      return Dict(word, this.sprache);
    },
    isSampleBarq(name) {
      var liste = [
        "BUB#001",
        "MAZ#002",
        "CUB#003",
        "GRD#004",
        "MOS#005",
        "MAN#006",
        "MOS#007",
        "MAZ#008",
        "MAN#009",
        "CUB#010",
        "BUB#011",
        "GRD#012",
      ];
      if (liste.includes(name)) {
        return true;
      }
      return false;
    },
    setMessage(msg) {
      this.$emit("msg", msg);
    },
    roundInfo(phase) {
      console.log(phase);
      if (phase == 1) return "1st Round";
      if (phase == 2) return "2nd Round";
    },
    checkMOS(name) {
      console.log("CHEKING MOS " + name);
      if (!name) {
        this.isMOS = false;
        return false;
      }
      if (name.includes("MOS")) {
        this.isMOS = true;
        return true;
      }
      this.isMOS = false;
      return false;
    },
    digits(digits) {
      //open Barq with these last 3 digits
      for (const sell in this.use_sellingList) {
        // console.log(sell);
        if (sell.includes(digits)) {
          if (
            this.use_sellingList[sell].status == "approved" ||
            this.checkMOS(sell)
          ) {
            this.currentOpenBarq_Codes = sell;
          }
          return true;
        }
      }
      this.$emit("msg", this.t("could not find barq"));
      return false;
    },
    resetOpen() {
      // console.log("RESETOPEN BARQ Was closed");
      this.currentOpenBarq = "";
      this.currentOpenFirewall = "";
      this.currentOpenBarq_Codes = "";
      this.barqOnlyForView = false;
      this.isMOS = false;
      this.$emit("msg", "barq was closed");
    },
    closeFirewall() {
      this.$emit("msg", "wallpiece was closed");
      this.currentOpenFirewall = "";
    },
    sendFirewall(img) {
      let data = {
        id: Date.now(), //time
        firewallId: this.currentOpenFirewall,
        rawData: img,
        // name: this.userName,
        type: "firewall",
      };

      //save it for transfer
      this.$emit("addToPlayerData", data);
      this.closeFirewall();
    },
    openFirewallPiece(id) {
      if (id in this.firewall) return;
      if (!this.editFirewall) return;
      this.currentOpenFirewall = id;
    },
    openBarq(sell, name) {
      if (!this.clickable) return;
      // console.log("open 1");
      if (!sell.price) return;
      if (!this.Fragen[name]) return; //maybe there is an error here, question was not filled in
      // console.log(sell.status);
      if (sell.status == "offer" || sell.status == "sold") return;
      if (sell.status == "approved") {
        // this.$emit("openBarq_forCodes", name);
        // this.currentOpenBarq_Codes = name;
        // console.log("OPENING FOR VIEW ONLY!!!!!!!!!!!!");
        this.barqOnlyForView = true;
        // return;
      }
      // console.log("open 2");
      // this.$emit("openBarq", name);
      this.currentOpenBarq = name;
      this.checkMOS(name);
    },
    openBarq_forCodes(name) {
      //code pupup window must show
      if (!name) return false;
      this.currentOpenBarq_Codes = name;
    },
    closeBarq() {
      this.currentOpenBarq = "";
      this.currentOpenBarq_Codes = "";
      this.barqOnlyForView = false;
      this.isMOS = false;
    },
    offerBarq(sell, name) {
      if (!this.clickable) return;
      if (!sell.price) return;
      // console.log(name);
      // if (this.gamePhase.phase == 0) {
      //   //sind noch in der samplerunde

      //   let data = {
      //     name: name,
      //     status: "offer",
      //   };
      //   this.$emit("addToPlayerData", data);
      //   // this.closeBarq()
      //   // this.sampleBarqs[name].status = "approved";
      //   return;
      // }
      let data = {
        id: Date.now(), //time
        barqId: name,
        name: this.userName,
        type: "offer",
      };
      // console.log("ys");
      this.$emit("msg", "barq will be sent to gamemaster");
      this.$emit("addToPlayerData", data);
    },
    getImage() {
      var imgData = this.$refs.Drawing.getImage();
      // console.log(imgData.dimensions);
      // console.log("getImage0");
      // if (this.gamePhase.phase == 0) {
      //   //sind noch in der samplerunde

      //   let data = {
      //     name: imgData.barqId,
      //     status: "offer",
      //   };
      //   this.$emit("addToPlayerData", data);
      //   this.closeBarq();
      //   // this.sampleBarqs[imgData.barqId].status = "open";
      //   return;
      // }
      // console.log("getImage1");
      //no imgdata here, or maybe have to wait
      // console.log("emit received");
      let data = {
        id: Date.now(), //time
        barqId: imgData.barqId,
        rawData: imgData.img,
        name: this.userName,
        dimensions: imgData.dimensions,
        type: "img",
      };

      // console.log(JSON.stringify(imgData.img));
      // const compressed_Gzip = await gzip(JSON.stringify(imgData.img));
      // console.log(compressed_Gzip);

      // const unCompressed = await ungzip(compressed_Gzip);
      // console.log(JSON.parse(unCompressed.toString()));

      //save it for transfer
      this.$emit("msg", "barq is sent to gamemaster");
      this.$emit("addToPlayerData", data);
      this.closeBarq();

      // console.log("data sent");
      // console.log(data);
    },

    codeSolved(name, bonus) {
      // console.log(name);
      // console.log(bonus);
      // if (this.gamePhase.phase == 0) {
      //   let val = 100;
      //   if (bonus) val = 125;

      //   let data = {
      //     name: name,
      //     status: "sold",
      //     sampleTurnover: val,
      //   };
      //   this.$emit("setSampleData", data);
      //   return;
      // }
      this.$http
        .post("/fullfillTransaction", {
          token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
          name: name,
          bonus: bonus,
        })
        .then((res) => {
          // console.log(res);
          if (res.status === 200 && res.data.type == "success") {
            // if (res.data.emptyRoom) {
            //   console.log("success, updateRoom, NO new Data");
            //   return true;
            // }

            // this.room = res.data.room;
            // this.room_playerSpecificData = [];
            // console.log("success, updateRoom, new Data");
            return true;
          }
          return false;
        });
    },
    loadHowTo() {
      // console.log("TRYOING TO LOAD:" + teleId);
      let img = "";
      // let img2 = "";
      try {
        img = require("../assets/howto_" + this.sprache + ".png");
      } catch (e) {
        console.log("img not found");
        this.$emit("msg", "Could not load how to");
        // this.currentOpenTele = "";
      }
      // try {
      //   img2 = require("../assets/howto_min.jpg");
      // } catch (e) {
      //   this.$emit("msg", "Could not load howto2");
      //   // this.currentOpenTele = "";
      // }
      return img;
    },

    //FILTERS
    numberFilter(n) {
      return parseInt(n).toLocaleString("de-DE");
    },
  },
  created() {
    if (this.gamePhase.phase == 0) {
      // this.use_sellingList = this.sample_sellingList;
      this.use_sellingList = {};
      for (const sell in this.sellingList) {
        // console.log(sell);
        if (this.isSampleBarq(sell)) {
          this.use_sellingList[sell] = this.sellingList[sell];
        }
      }
    } else if (this.gamePhase.phase == 1) {
      this.resetOpen();
      this.use_sellingList = {};
      let i = 0;
      for (const s of Object.keys(this.sellingList)) {
        if (!this.isSampleBarq(s)) {
          this.use_sellingList[s] = this.sellingList[s];
          if (i == 17) break;
          i++;
        }
      }
      // console.log(this.use_sellingList);
    } else {
      this.resetOpen();
      for (const sell in this.sellingList) {
        if (!this.isSampleBarq(sell)) {
          this.use_sellingList[sell] = this.sellingList[sell];
        }
      }
    }
    console.log("WATCHER");
    if (this.gamePhase.firewall) {
      console.log("inside");
      this.showFirewall = this.gamePhase.firewall.show;
      this.editFirewall = this.gamePhase.firewall.editable;
      // console.log(newVal.firewall.editable);
    }

    if (this.gamePhase.hack.barqul == "on") {
      this.clickable = true;
    } else {
      this.clickable = false;
    }

    for (const s in this.use_sellingList) {
      if (this.use_sellingList[s].status == "non") continue;
      if (this.use_sellingList[s].status && this.use_sellingList[s].price) {
        this.turnover[this.use_sellingList[s].status]++;

        if (this.use_sellingList[s].status == "sold") {
          this.turnover.total += this.use_sellingList[s].price;
        }
      }
    }

    window.addEventListener("keydown", (event) => {
      if (event.keyCode == 27) {
        this.closeBarq();
      }
      // do something
    });
  },
};
</script>

<style scoped>
#barqGrid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 640px;
  height: 547px;
  justify-content: space-around;
  overflow: scroll;
  z-index: 2;
}

#barqGrid::-webkit-scrollbar {
  display: none;
}

.roundInfo {
  display: flex;
  position: absolute;
  bottom: -27px;
  left: 50%;
  width: 770px;
  font-size: 20px;
  transform: translate(-50%, 0);
  justify-content: space-between;
}

/* Hide scrollbar for Chrome, Safari and Opera */
#container::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
#container {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.firewall_border {
  position: absolute;
  left: 0px;
  top: -24px;
  width: calc(100% - 8px);
  height: calc(100% + 50px);
}

.firewall_border:before {
  content: "";
  width: calc(100% - 53px);
  height: calc(100% - 51px);
  border: 8px solid rgb(89 89 89 / 80%);
  position: absolute;
  left: 21px;
  top: 17px;
}

.firewall_border:after {
  content: "";
  width: calc(100% - 14px);
  height: calc(100% - 17px);
  border: 8px solid rgb(89 89 89 / 80%);
  position: absolute;
}

.wallpieceHover:hover {
  background: rgb(252 102 33 / 59%);
}

.T>div>.firewall_img,
.B>div>.firewall_img {
  width: 100%;
  height: 25px;
}

.L>div>.firewall_img,
.R>div>.firewall_img {
  width: 25px;
  height: 100%;
}

.T {
  left: 0px;
  top: -25px;
  display: flex;
  width: calc(100% - 7px);
}

.B {
  left: 0px;
  display: flex;
  width: calc(100% - 7px);
}

.R {
  top: 0px;
  right: 7px;
}

.T,
.B,
.R {
  position: absolute;
}

.L>.wallpiece,
.R>.wallpiece {
  height: 92px;
  width: 25px;
  line-height: 92px;
}

.T>.wallpiece,
.B>.wallpiece {
  flex: 1;
  height: 25px;
  line-height: 25px;
}

.wallpiece {
  text-align: center;
  /* border: 1px solid grey; */
  color: grey;
  box-shadow: 1px 0 0 0 grey, 0 1px 0 0 grey, 1px 1px 0 0 grey,
    /* Just to fix the corner */
    1px 0 0 0 grey inset, 0 1px 0 0 grey inset;
}

.firewall {
  width: calc(43% + 60px);
  position: absolute;
  /* z-index: -1; */
  margin-left: 4px;
  touch-action: none;
  margin-top: -3px;
  max-width: 700px;
}

.howto {
  width: 100%;
  border: 4px solid var(--barq-orange);
  border-radius: 20px;
  padding: 7px;
  background-color: white;
}

.howto_img {
  width: 97%;
}

.PopUPBarq {
  display: flex;
  background: white;
  margin: 0 auto;
  height: calc(95vh - 40px);
  padding: 2px;
  aspect-ratio: 1013 / 680;
  margin-top: 7px;
  max-height: 692px;
  max-width: 1028px;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.currentOpenBarq {
  display: flex;
  position: fixed;
  z-index: 2;
  /* padding-top: 100px; */
  background: hsl(19deg 97% 56% / 15%);
  height: 100%;
  top: 0px;
  left: 0px;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  width: 100%;
}

.currentOpenBarq_codes {
  display: flex;
  position: fixed;
  z-index: 2;
  padding-top: 100px;
  background: hsl(19deg 97% 56% / 15%);
  height: 100%;
  top: 0px;
  left: 0px;
  backdrop-filter: blur(3px);
  width: 100%;
}

.debarqd {
  font-family: Herculanum;
  color: black;
  font-size: 9px;
}

.hacked>img {
  width: 54px;
}

.hacked,
.removed {
  background: #f2f2f2;
  width: 81px;
  height: 81px;
  margin: 2px;
  list-style: none;
  color: white;
  text-align: center;
  border: 1px solid #f2f2f2;
  border-radius: 20px;
  position: relative;
}

.full_height {
  height: 100%;
}

.pointer:hover {
  cursor: pointer;
}

.name {
  margin-top: 15px;
}

.price {
  margin-top: 10px;
}

.name,
.price {
  font-family: "Calibri-Bold";
  font-size: 16px;
}

#container {
  display: flex;
  flex-wrap: wrap;
  width: 43%;
  max-width: 640px;
  height: 547px;
  margin: 0 30px;
  justify-content: space-around;
  /* z-index: 2; */
  margin-top: 35px;
  font-size: 14px;
  font-family: Calibri-Bold;
  overflow: scroll;
}

.full_height>div {
  margin-top: 10px;
}

.barqs:before {
  border: 1px solid white;
  content: "";
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 16px;
  pointer-events: none;
}

.barqs {
  background: var(--barq-orange);
  width: 81px;
  height: 81px;
  list-style: none;
  color: white;
  text-align: center;
  border: 3px solid white;
  border-radius: 20px;
  display: flex;
  position: relative;
  flex-direction: column;
}

.b_name {
  width: 100%;
  height: 100%;
}

.offer {
  font-size: 0.7em;
  border: 2px solid white;
  border-radius: 6px;
  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
}

.offer:hover {
  cursor: pointer;
}

.green {
  background-color: var(--barq-green);
}

.hellblau,
.lightblue {
  background-color: var(--barq-lightblue);
}

.dunkelblau,
.blue {
  background-color: var(--barq-darkblue);
}

/*Media rules*/
/* @media only screen and (max-width: 1030px) {
  #container {
    height: 600px !important;
    margin-top: 1px;
  }

  .L > .wallpiece,
  .R > .wallpiece {
    height: 100px;
    width: 25px;
    line-height: 100px;
  }
} */

@media only screen and (max-width: 1349px) {
  #container {
    overflow: scroll;
  }
}

@media only screen and (max-width: 1100px) {
  .firewall {
    width: calc(43% + 45px);
  }
}

@media only screen and (max-width: 1020px) {
  .firewall {
    width: calc(43% + 35px);
  }
}
</style>
